 
import { useModalStore } from 'stores/modal';
import { DisabledField, ModalType } from 'core/useCases/modal/types';
import { useTaskById } from 'core/api/tasks';
import Edit from 'images/icons/Edit.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type UpdateTaskButtonProps = {
    taskId: string;
};

const UpdateTaskButton: FC<UpdateTaskButtonProps> = ({ taskId }) => {
    const { t } = useTranslation();
    const openModal = useModalStore((s) => s.openModal);
    const task = useTaskById(taskId).data;

    const openTaskModal = () => {
        openModal({
            defaultValues: task,
            disabledFields: [DisabledField.ContactId, DisabledField.ApplicationId],
            title: t('task-list.update-task'),
            type: ModalType.Task,
        });
    };

    return (
        <button onClick={() => openTaskModal()} type="button">
            <Edit />
        </button>
    );
};

export default UpdateTaskButton;
